export enum LogLevel {
  debug = 0,
  info = 1,
  warn = 2,
  error = 3,
}

type Levels = keyof typeof LogLevel;

const toLevel = (level: string | LogLevel) =>
  typeof level === 'string' ? LogLevel[level.toLowerCase() as Levels] : level;

/**
 * Logging utility governed by config logLevel
 */
class Log {
  configuredLevel: LogLevel = LogLevel.info;

  constructor(configuredLevel: string | LogLevel) {
    this.configuredLevel = toLevel(configuredLevel) ?? LogLevel.info;
  }

  debug = (...args: unknown[]) => this.log(LogLevel.debug, args);
  info = (...args: unknown[]) => this.log(LogLevel.info, args);
  warn = (...args: unknown[]) => this.log(LogLevel.warn, args);
  error = (...args: unknown[]) => this.log(LogLevel.error, args);

  private log(level: LogLevel, args: unknown[]) {
    if (this.configuredLevel <= level) {
      // eslint-disable-next-line no-console
      console[LogLevel[level] as Levels](...args);
    }
  }
}

export default Log;
